export default class PolicyAdoption {
  constructor(client) {
    this.client = client;
    this.resourceUrl = "";
  }

  policiesForReview(healthPlanKey) {
    return this.client.get(`/healthplan/policiesforreview`, {
      params: { healthPlanKey },
    });
  }
  importVariance(healthPlanKey, formData) {
    return this.client.postForm(
      `/policy/healthplan/${healthPlanKey}/importVariance`,
      formData,
      {
        Headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
  }
  importAdoptionDecisions(healthPlanKey, formData) {
    return this.client.postForm(
      `/policy/healthplan/${healthPlanKey}/uploadExcelAdoptionDecisions`,
      formData,
      {
        Headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
  }
  updatePoliciesForReview(healthPlanKey, updatedPolicy) {
    return this.client.put(
      `/healthplan/updateClientAdoptionDecision?healthPlanKey=${healthPlanKey}`,
      updatedPolicy
    );
  }
}
